export {MagicTextComponent} from './MagicTextComponent';
export type {MagicTextComponentDefinition} from './MagicTextComponent';
export {ComponentDefinition} from './MagicTextDefinition';
export type {SchemaType} from './MagicTextDefinition';
export {MagicTextPreviewComponent} from './MagicTextPreviewComponent';

import {Registry} from '@backstage-components/base';
import {MagicTextModule} from './MagicTextModule';
import {ComponentDefinition} from './MagicTextDefinition';
Registry.register(ComponentDefinition, MagicTextModule);
